module.exports = __webpack_public_path__ + "resources/img/certi_iso_iec_29100_m.af2daa5cd2793e8da17bd99f969f2252.png";